/* eslint-disable no-undef */
import * as algosdk from 'algosdk';
import { Buffer } from "buffer";

const checkAlgoSignerWallet1 = async() => {
    if (typeof algorand !== "undefined") {
        console.log("Inside check algo")
        const acc = await window.algorand.enable({
                genesisID: 'testnet-v1.0',
                // genesisHash: 'SGO1GKSzyE7IEPItTxCByw9x8FmnrCDexi9/cOUJOiI=',
            })
            .then(d => {
                console.log("D", d);
                const accounts = d.accounts;
                console.log("Accounts", accounts);
                return accounts;
            })

        .catch(e => console.error(e));
        return acc;
    } else {
        console.log("AlgoSigner is not installed");
    }

};

const sendTxn = async(signedTxs) => {
    console.log("TXN", signedTxs)
    const res = await window.algorand.postTxns(signedTxs)
        .then(async d => {
            // const data = waitForAlgosignerConfirmation(signedTxs);
            console.log("sendREsponse", d);
            // console.log("data", data);
            return d;
        })
        .catch(e => console.error(e));
    return res

};

const signAndSendTxn = async(trans) => {
    try {
        // FetchServerData.showLoaderWithText();
        // let Buffer = require('buffer').Buffer
        console.log("Trans: ", trans);

        const recovered_pay_txn = algosdk.decodeUnsignedTransaction(
            Buffer.from(trans.toString(), "base64")

        );
        let base64Tx = await window.algorand.encoding.msgpackToBase64(
            recovered_pay_txn.toByte()

        );
        console.log("Recoveryptm--", recovered_pay_txn)

        console.log("base64Tx", base64Tx);
        // FetchServerData.updateLoaderText("Sign transaction");
        const signedTxn = await window.algorand.signTxns([{ txn: base64Tx }])
            .then(async d => {
                const tx = await sendTxn(d);
                console.log("tx", tx.txnIDs[0]);
                return tx.txnIDs[0];
            })
            .catch(e => console.error(e));
        return signedTxn;
    } catch (error) {

        console.log("Error", error.message)
        throw new Error(error);

    }
};

export default {
    checkAlgoSignerWallet1,
    sendTxn,
    signAndSendTxn
};